// 新人礼包
export const newGift = {
  en: {
    currency: "$",
    // 邀请人
    inviter: {
      // 满减
      full: 300,
      reduction: 75,
    },
    //被邀请人
    beInviter: {
      // 满减
      full: "250+",
      reduction: 75,
      
      // 被邀请人消费满多少 邀请人才能得到奖励
      spend: '200+',
    },
    // 不参与邀请活动，直接注册的新人礼包
    gift: {
      full: "250+",
      reduction: 75,
    },
  },
  zh: {
    currency: "￥",
    inviter: {
      full: 3000,
      reduction: 300,
    },
    beInviter: {
      full: 1600,
      reduction: 120,
      spend: 799,
    },
    gift: {
      full: 1600,
      reduction: 120,
    },
  },
};
